<template>
	<pl-table-cell-controller
		ref="controller"
		class="lv-table-row"
		:default-editing="defaultEnableEditable"
		:edit-source-row="editSourceRow"

		@click.native="lv_click"
		@dblclick.native="lv_dblclick"
		@mouseenter.native="lv_enter"
		@mouseleave.native="lv_leave"
		:class="{'lv-table-row-hover':lv_hover,'lv-table-row-selected':lv_selected,'lv-table-row-editing':lv_editing}">
		<td v-for="(col,colIndex) in columns" :key="colIndex">
			<lv-table-cell
				:is-fixed="col.fixed === fixed"
				:height="rowHeight"
				:width="col.width"
				:align="col.align">
				<!--:scope-slot-func="col.scopeSlotFunc" 有点问题，是不是可以考虑换成 col.colScopedSlot -->
				<link-table-cell-normal
					v-if="fastRender && col.fastRender && !col.click"
					:render-func="col.renderFunc"
					:scope-slot-func="col.scopeSlotFunc"
					:text="row[col.field]"
					:data="{row,rowIndex,col,colIndex,editRow:row,showRow:row,editable:false,fixedRow}"/>
				<lv-scope-slot v-else :scope-slot-func="col.colScopedSlot" :data="{row,rowIndex,col,colIndex,editRow,fixedRow}"/>
			</lv-table-cell>
		</td>
	</pl-table-cell-controller>
</template>

<script>
	import LvTableCell from './lv-table-cell';
	import {TableMixin} from './index';
	import PlTableCellController from './pl-table-cell-controller';
	import LvScopeSlot from "../render/lv-scope-slot";

	export default {
		name: "lv-table-row",
		components: {LvScopeSlot, PlTableCellController, LvTableCell},
		mixins: [TableMixin],
		props: {
			columns: {},
			row: {},
			rowIndex: {},
			editRow: {},
			fixedRow: {type: Boolean},
		},
		data() {
			return {
				lv_baseTable: null,
				lv_hover: false,
				lv_selected: false,
				lv_editing: !!this.defaultEnableEditable,
				items: [],
			}
		},
		mounted() {
			if (!this.fixedRow) {
				this.lv_baseTable = this.$lv.$dom.findComponentUpward(this, 'lv-base-table')
				this.lv_baseTable.lv_rowAdd({row: this, position: this.fixed})
			}
		},
		beforeDestroy() {
			!!this.lv_baseTable && this.lv_baseTable.lv_rowRemove({row: this, position: this.fixed})
		},
		methods: {
			/**
			 * 选中
			 * @author  韦胜健
			 * @date    2019/1/9 18:04
			 */
			select() {
				this.lv_selected = true
			},
			/**
			 * 取消选中
			 * @author  韦胜健
			 * @date    2019/1/9 18:04
			 */
			unselect() {
				this.lv_selected = false
			},
			/**
			 * 校验
			 * @author  韦胜健
			 * @date    2019/1/14 16:52
			 */
			validate() {
				return this.$refs.controller.validate()
			},
			/**
			 * 开启编辑状态
			 * @author  韦胜健
			 * @date    2019/1/8 10:24
			 */
			async enableEdit() {
				this.lv_editing = true
				this.$refs.controller.enableEdit()
			},
			/**
			 * 关闭编辑状态
			 * @author  韦胜健
			 * @date    2019/1/8 10:24
			 */
			disableEdit() {
				this.lv_editing = false
				this.$refs.controller.disableEdit()
			},
			/**
			 * 单击事件
			 * @author  韦胜健
			 * @date    2019/1/8 10:23
			 */
			lv_click() {
				const param = {row: this, rowIndex: this.rowIndex, position: this.fixed}
				!!this.lv_baseTable && this.lv_baseTable.$emit('rowClick', param)
				this.$emit('click', param)
			},
			/**
			 * 双击事件
			 * @author  韦胜健
			 * @date    2019/1/8 10:23
			 */
			lv_dblclick() {
				const param = {row: this, rowIndex: this.rowIndex, position: this.fixed}
				!!this.lv_baseTable && this.lv_baseTable.$emit('rowDblClick', param)
				this.$emit('dblclick', param)
			},
			/**
			 * 鼠标悬浮事件
			 * @author  韦胜健
			 * @date    2019/1/8 10:23
			 */
			lv_enter() {
				!!this.lv_baseTable && this.lv_baseTable.$emit('rowEnter', {row: this, rowIndex: this.rowIndex, position: this.fixed})
			},
			/**
			 * 鼠标离开事件
			 * @author  韦胜健
			 * @date    2019/1/9 11:22
			 */
			lv_leave() {
				!!this.lv_baseTable && this.lv_baseTable.$emit('rowLeave', {row: this, rowIndex: this.rowIndex, position: this.fixed})
			},
		}
	}
</script>

<style lang="scss">
	// $table-selected-bg-color: rgba(31, 116, 255, 0.07);;
	$table-selected-bg-color: #BBD5FF;
	@include themeify {
		.lv-table-row {
			transition: background-color 150ms linear;

			.lv-table-cell {
				font-size: 12px;

				.lv-scope-slot {
					width: 100%;
				}
			}

			&:not(.lv-table-column):not(:last-child) {
				.lv-table-cell {
					border-bottom: solid $base-table-border-size $base-table-border-color;
				}
			}

			&.lv-table-row-hover {
				background-color: $table-selected-bg-color; //rgba(31, 116, 255, 0.07);
			}

			&.lv-table-row-editing {

				.lv-table-cell {
					/*border-bottom: none;
					position: relative;

					&:before {
						position: absolute;
						top: -1px;
						left: 0;
						right: 0;
						background-color: white;
						content: '';
						height: 1px;
					}*/

					.link-input {
						margin-left: -$base-table-cell-padding;
						width: calc(100% + #{$base-table-cell-padding - 4px}) !important;

						input {
							padding-left: 10px;
							padding-right: 10px;
						}
					}
				}

				/*&.lv-table-row-selected, &.lv-table-row-hover {
					.link-input:not(.link-input-focus):not(.link-input-invalid) {
						border-color: white !important;
					}
				}*/

			}

			&.lv-table-row-selected {
				background-color: $table-selected-bg-color; //rgba(31, 116, 255, 0.07);
			}
		}
	}
</style>
